export default "__VITE_ASSET__DmrAZaQV__"